module.exports = __webpack_public_path__ + "media/images/landing-indian-matrimonial-phone-2-931f395b82a29fbdcf9b79d681cd4f2b.png";